/*
  Fatigue section ids
 */

export default [
  'motivation',
  'exercise',
  'tendency',
  'physicalActivity',
  'problems',
  'sustainedPhysicalActivity',
  'duties',
  'disability',
  'life',
];
